import { render, staticRenderFns } from "./DigitDisplay.vue?vue&type=template&id=08e7dea4&scoped=true&"
import script from "./DigitDisplay.vue?vue&type=script&lang=js&"
export * from "./DigitDisplay.vue?vue&type=script&lang=js&"
import style0 from "./DigitDisplay.vue?vue&type=style&index=0&id=08e7dea4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e7dea4",
  null
  
)

export default component.exports